
<template>
	<v-app id="inspire">
      <app-bar v-if="appBarIsVisible" :appBarColor="appBarColor" :appLogo="appLogo"></app-bar>

      <v-main>
        <router-view :key="String($route.name || '').replace(/^custom-/, '') === 'document-list' ? $route.fullPath : undefined"></router-view>
      </v-main>
    </v-app>
</template>

<script>
import AppBar from "../src/components/AppBar.component";
import { CommonService } from "./services/common-service";
import { routeContext } from "./services/customization-context";

export default {
	components: { AppBar },
	data() {
		return {
			snackbar: false,
			snackbarTimeout: 6000,
			appBarColor: "#043351",
			appLogo: null,
			appBarIsVisible: false,
			footerColor: "",
			footerTextColor: "",
			appBarTextColor: "",
			buttonColor: "",
			buttonTextColor: "",
			signatureButtonColor: "",
			signatureButtonTextColor: "",
			rejectButtonColor: "",
            rejectButtonTextColor: "",
            customizationGeneration: 0,
            associationText: ""
		};
	},


/*
    mounted() {
      const btnBg = this.$store.state.common.buttonColor || '#F36E21';
      const btnTxt = this.$store.state.common.buttonTextColor || '#FFFFFF';

      document.documentElement.style.setProperty('--btn-bg-color', btnBg);
      document.documentElement.style.setProperty('--btn-text-color', btnTxt);
      console.log("Botón " + btnBg + " con texto " + btnTxt);
    }, */


	watch: {

		footerTextColorFromStore(newColor) {
          console.log("Aplicando estilo Footer Text Color: " + newColor);
          document.documentElement.style.setProperty('--footer-txt-color', newColor);
        },

        footerColorFromStore(newColor) {
            document.documentElement.style.setProperty('--footer-bg-color', newColor);
          },

		notification(payload) {
			if (payload) {
				this.snackbar = true;
			}
			setTimeout(() => {
				this.snackbar = false;
				this.$store.dispatch("REMOVE_NOTIFICATION");
			}, this.snackbarTimeout);
		},
        currentRoute() {
            const name = String(this.currentRoute.name || '').replace(/^custom-/, '');
            if (name === 'general' || name === 'document-list' || ['login', 'certlogin', 'my-signatures'].includes(name)) {
                this.$store.commit('common/setCustomizationCurrent', null);
                if (name === 'document-list') this.$store.commit('common/setCustomizationBatch', null);
                else this.$store.commit('common/beginCustomizationBatch');
            }
            this.updateCustomization();
        },
        customizationBatch() { this.updateCustomization(); },
        verifiedCustomizationAuth() { this.updateCustomization(); }

	},
	computed: {
        customizationBatch() { return this.$store.state.common.customizationBatch; },
        verifiedCustomizationAuth() { return this.$store.state.common.customizationVerifiedAuth; },
		footerColorFromStore() {
          return this.$store.state.common.footerColor;
        },
        footerTextColorFromStore() {
            console.log("Color del texto de Footer: " + this.$store.state.common.footerTextColor);
            return this.$store.state.common.footerTextColor;
          },

		notification() {
			return this.$store.state.common.notification;
		},
		currentRoute() {
			return this.$route;
		}
	},
	methods: {
        updateCustomization() {
            const route = this.currentRoute || {};
            const name = String(route.name || '').replace(/^custom-/, '');
            const association = route.params && route.params.association;
            const batch = this.customizationBatch;
            ++this.customizationGeneration;
            this.appBarIsVisible = false;
            this.appLogo = null;
            this.$store.commit('common/setAppBarColor', '#043351');
            this.$store.commit('common/setAppBarTextColor', '#FFFFFF');
            this.$store.commit('common/setFooterColor', '#043351');
            this.$store.commit('common/setFooterTextColor', '#FFFFFF');
            this.$store.commit('common/setButtonColor', '#F36E21');
            this.$store.commit('common/setButtonTextColor', '#FFFFFF');
            this.$store.commit('common/setSignatureColor', '#47D764');
            this.$store.commit('common/setSignatureTextColor', '#FFFFFF');
            this.$store.commit('common/setRejectColor', '#FF000D');
            this.$store.commit('common/setRejectTextColor', '#FFFFFF');
            this.$store.commit('common/setAssociationText', '');
            if (name === 'document-list' && route.query && route.query.token && batch === null) return;
            let context = routeContext(route, batch || [], this.$store.state.common.customizationCurrent);
            const verified = this.verifiedCustomizationAuth;
            const verifiedCurrent = verified && context && String(verified.requestId) === String(context.requestId) && verified.token === context.token;
            const verifiedBatch = verified && Array.isArray(batch) && verified.batchEpoch === this.$store.state.common.customizationBatchEpoch &&
                batch.some(item => String(item.id) === String(verified.requestId) && item.apiToken === verified.token);
            if (context && !context.authId && (verifiedCurrent || verifiedBatch)) context = { ...context, authId: verified.authId };
            if (name === 'general') this.$store.commit('common/setCustomizationCurrent', context);
            this.getCustomPropertise(association, context);
        },
		getCustomPropertise(currentAssociation, context) {
            const generation = this.customizationGeneration;
			CommonService.getCustomPropertise(currentAssociation, context).then((response) => {
                if (generation !== this.customizationGeneration) return;
                if (!response || !response.data) { this.clearCustomPropertise(); return; }
				if(response.data.color != ""){
					this.appBarColor = response.data.color;
				}else{
					this.appBarColor = `#043351`;
				}
				if(response.data.image != ""){
					this.appLogo = 'data:image/svg+xml;base64,' + response.data.image;
					console.log("[LOGO] response.data.image (raw):", response.data.image);
				}else{
					this.appLogo = `data:image/png;base64,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`;
				}
				if(response.data.footer.color != ""){
                    this.footerColor = response.data.footer.color;
                }else{
                    this.footerColor = `#043351`;
                }
                if(response.data["footer-text"].color != ""){
                    this.footerTextColor = response.data["footer-text"].color;
                }else{
                    this.footerTextColor = `#FFFFFF`;
                }
                if(response.data["appbar-text"].color != ""){
                    this.appBarTextColor = response.data["appbar-text"].color;
                }else{
                    this.appBarTextColor = `#FFFFFF`;
                }
                if(response.data.button.color != ""){
                    this.buttonColor = response.data.button.color;
                }else{
                    this.buttonColor = `#F36E21`;
                }
                if(response.data["button-text"].color != ""){
                    this.buttonTextColor = response.data["button-text"].color;
                }else{
                    this.buttonTextColor = `#FFFFFF`;
                }
                if(response.data["signature-button"].color != ""){
                    this.signatureButtonColor = response.data["signature-button"].color;
                }else{
                    this.signatureButtonColor = `#47D764`;
                }
                if(response.data["signature-button-text"].color != ""){
                    this.signatureButtonTextColor = response.data["signature-button-text"].color;
                }else{
                    this.signatureButtonTextColor = `#FFFFFF`;
                }
                if(response.data["signature-button"].color != ""){
                    this.rejectButtonColor = response.data["reject-button"].color;
                }else{
                    this.rejectButtonColor = `#FF000D`;
                }
                if(response.data["reject-button-text"].color != ""){
                    this.rejectButtonTextColor = response.data["reject-button-text"].color;
                }else{
                    this.rejectButtonTextColor = `#FFFFFF`;
                }
                if(response.data["footerText"] != ""){
                    this.associationText = response.data["footerText"];
                }else{
                    this.associationText = ``;
                }

				this.$store.commit('common/setHasAssociation', Boolean(currentAssociation));
				console.log("Footer Color: " + this.footerColor);
				console.log("Button Color: " + this.buttonColor);
				console.log("Button Color Text: " + this.buttonTextColor);
				console.log("AppBar Color en App: " + this.appBarColor);
				console.log("signature Button Color en App: " + this.signatureButtonColor);
				console.log("signature Button Text Color en App: " + this.signatureButtonTextColor);
				console.log("AssociationText: " + this.associationText);


				this.$store.commit('common/setFooterColor', this.footerColor);
				this.$store.commit('common/setFooterTextColor', this.footerTextColor);
				this.$store.commit('common/setAppBarColor', this.appBarColor);
				this.$store.commit('common/setAppBarTextColor', this.appBarTextColor);
				this.$store.commit('common/setButtonColor', this.buttonColor);
				this.$store.commit('common/setButtonTextColor', this.buttonTextColor);
				this.$store.commit('common/setSignatureColor', this.signatureButtonColor);
				this.$store.commit('common/setSignatureTextColor', this.signatureButtonTextColor);
				this.$store.commit('common/setRejectColor', this.rejectButtonColor);
                this.$store.commit('common/setRejectTextColor', this.rejectButtonTextColor);
                this.$store.commit('common/setAssociationText', this.associationText);
				console.log("Vuex buttonColor (post commit):", this.$store.state.common.buttonColor);
                console.log("Vuex buttonTextColor (post commit):", this.$store.state.common.buttonTextColor);
                localStorage.setItem('signatureButtonColor', this.signatureButtonColor);
                localStorage.setItem('signatureButtonTextColor', this.signatureTextButtonColor);

				// 🔧 Aplicar valores inmediatamente después
                document.documentElement.style.setProperty('--btn-bg-color', this.buttonColor);
                document.documentElement.style.setProperty('--btn-text-color', this.buttonTextColor);
                this.$store.commit('common/setInitialized', true);
				this.appBarIsVisible = true;
			}).catch(() => {
                if (generation === this.customizationGeneration) this.clearCustomPropertise();
			});
		},
		clearCustomPropertise(currentAssociation) {
			this.appBarIsVisible = true;
			this.appBarColor = null;
			this.appLogo = null;
			this.$store.commit('common/setHasAssociation', false);

			if (currentAssociation) {
				this.$router.push({
					name: this.currentRoute.name.replace("custom-", ""),
					params: this.currentRoute.params,
					query: this.currentRoute.query
				}).catch(() => { })
			}
		},
	}
};
</script>

<style>
body {
	background: #ffffff;
}
</style>